/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_CaptionInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_1_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A small, self-contained budget is easier to evaluate than a workbook with external dependencies. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_1_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相比依赖外部数据的工作簿，独立的小型预算表更容易验证。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "A small, self-contained budget is easier to evaluate than a workbook with external dependencies. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_1_figure_caption = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Figure_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_1_figure_caption(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_1_figure_caption(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_1_figure_caption as "gc.search_guides.gridcraft_vs_excel.sections.1.figure.caption" }